import * as yup from 'yup';

const SchemaDocumentosDeRespaldo = yup.object().shape({});

export { SchemaDocumentosDeRespaldo };
